export const PRODUCTS = [
  {
    id: "qh-2",
    name: "2 QHearts",
    count: 2,
    price: 14.9,
    badge: null,
    tagline: "Für den ersten echten Moment.",
  },
  {
    id: "qh-4",
    name: "4 QHearts",
    count: 4,
    price: 24.9,
    badge: "Beliebt",
    tagline: "Mehr Momente. Mehr echte Begegnungen.",
  },
  {
    id: "qh-8",
    name: "8 QHearts",
    count: 8,
    price: 39.9,
    badge: null,
    tagline: "Für alle, die bewusst dabei sind.",
  },
  {
    id: "qh-12",
    name: "12 QHearts",
    count: 12,
    price: 49.9,
    badge: "Bester Deal",
    tagline: "Dein Vorrat an echten Zeichen.",
  },
];
